const paths = {
  listEmailNotifications: '/notifications/email',
  listConsoleNotifications: '/notifications/console',
  listWebServiceNotifications: '/notifications/webService',
  listNotifications: '/notifications/:screenType'
};

export default paths;
